module.exports = __webpack_public_path__ + "img/remax-saarlouis.f769984b.png";